// extracted by mini-css-extract-plugin
module.exports = {"rotating":"RefreshButton_rotating__28Fr1"};